import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appFloatMinMax]',
})
export class FloatMinMaxDirective {
  @Input() maxValue?: number;
  @Input() minValue?: number;

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Оставляем только цифры и одну запятую
    value = value.replace(/[^0-9,]/g, '');
    const parts = value.split(',');
    if (parts.length > 2) {
      value = parts[0] + ',' + parts[1];
    }

    // Если первый символ 0, второй может быть только запятой
    if (value.length > 1 && value[0] === '0' && value[1] !== ',') {
      value = '0';
    }

    if (value && value !== '0' && value !== '0,') {
      const floatValue = parseFloat(value.replace(',', '.'));
      if (
        (this.maxValue !== undefined && !isNaN(this.maxValue) && floatValue > this.maxValue) ||
        (this.minValue !== undefined && !isNaN(this.minValue) && floatValue < this.minValue)
      ) {
        value = value.slice(0, -1);
      }
    }

    if (input.value !== value) {
      input.value = value;
      input.dispatchEvent(new Event('input'));
    }
  }
}
